import { createContext } from 'react'

const WatchListContext = createContext();

export default WatchListContext;